import getField from '@form/formGenerator'

export const mailTemplateSaveUrl = `${import.meta.env.VITE_API_URL}/api/mail-templates`

export const mailTemplateFormObject = {
  id: '',
  type: '',
  title: '',
  sender: '',
  receiver: '',
  toCC: '',
  toCCI: '',
  messages: '',
  isActive: false,
  isSystme: false,
  missionId: '',
  language: 'fr'
}

export const mailTemplateFormFields = (
  mailTemplateFormObject,
  updateFormObject,
  updateFormObjectProp,
  saveForm,
  errors,
  isLoading,
  t,
  mailTemplateTypes,
  languages
) => {
  const fields = [
    {
      type: 'select',
      name: 'language',
      label: t('labels.language'),
      value: mailTemplateFormObject.language,
      key: 'mailTemplateFormObject-language',
      cssClass: 'mailTemplate-type column is-12',
      options: languages,
      isRequired: true
    },
    {
      type: 'select',
      name: 'type',
      label: t('labels.mail_template_type'),
      value: mailTemplateFormObject.type,
      key: 'mailTemplateFormObject-type',
      cssClass: 'mailTemplate-type column is-12',
      withIcon: false,
      help: t('help.mail_template_type_help'),
      options: mailTemplateTypes,
      disabled: false,
      isRequired: true
    },
    {
      type: 'text',
      name: 'title',
      label: t('labels.title'),
      value: mailTemplateFormObject.title,
      key: 'mailTemplateFormObject-title',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'sender',
      label: t('labels.sender'),
      value: mailTemplateFormObject.sender,
      key: 'mailTemplateFormObject-sender',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'receiver',
      label: t('labels.receiver'),
      value: mailTemplateFormObject.receiver,
      key: 'mailTemplateFormObject-receiver',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'toCC',
      label: t('labels.to_cc'),
      value: mailTemplateFormObject.toCC,
      key: 'mailTemplateFormObject-toCC',
      cssClass: 'column is-6'
    },
    {
      type: 'text',
      name: 'toCCI',
      label: t('labels.to_cci'),
      value: mailTemplateFormObject.toCCI,
      key: 'mailTemplateFormObject-toCCI',
      cssClass: 'column is-6'
    },
    {
      type: 'tinymce',
      config: 'essential',
      name: "message",
      cssClass: 'column is-12 mission-message',
      disabled: false,
      label: t('labels.message'),
      initialValue: mailTemplateFormObject.message,
      isRequired: true
    },
    {
      type: 'switcher',
      name: 'isActive',
      label: t('labels.is_active'),
      value: mailTemplateFormObject.isActive,
      cssClass: 'column is-6',
      key: 'mailTemplateFormObject-isActive',
    },
    {
      type: 'button',
      buttons: true,
      callback: saveForm,
      cancel: false,
      validateText: t('actions.save'),
      cssClassParent: 'column is-12',
      cssClassValidate: 'button is-blue',
      validateIcon: 'icon-done',
      key: 'mailTemplateFormObject-form',
      isLoading
    },
    {
      type: 'hidden',
      name: 'id',
      value: parseInt(mailTemplateFormObject.id),
      key: 'mailTemplateFormObject-id'
    },
    {
      type: 'hidden',
      name: 'missionId',
      value: parseInt(mailTemplateFormObject.missionId),
      key: 'sterilizationCitizenCallFormObject-missionid'
    },
  ]
  return fields.map(function (field) {
    return getField({ ...field, error: errors[field.name] ? errors[field.name].errors : '' }, updateFormObject, updateFormObjectProp)
  })
}